<template>
  <div class="jobfair-list index-bar-list">
    <header>
      <swipe
        :autoplay="3000"
        style="height: 106px; background-color: #378EDE;"
        indicator-color="#f00"
      >
        <swipe-item v-for="(image, index) in images" :key="index">
          <div class="swipe-content" :style="'background-image: url(' + image + ')'"></div>
          <!-- <img :src="image" /> -->
        </swipe-item>
      </swipe>
    </header>
    <index-bar :sticky-offset-top="46">
      <index-anchor>
        <section>
          <cell-group>
            <field
              v-model="jobfair_name"
              placeholder="请输入企业名称"
              left-icon="search"
              @click-left-icon="searchFn"
            >
              <van-button slot="button" size="small" type="info" @click="searchFn" plain>搜索</van-button>
            </field>
          </cell-group>
        </section>
      </index-anchor>
      <!-- <section>
      <wy-select :list="SelectList"></wy-select>
      </section>-->

      <section class="list" v-if="loadData">
        <!-- <wy-card margin="0 0 0.1rem 0" padding="0.05rem 0.1rem">
        <div>会场动态</div>
        </wy-card>-->

        <pull-refresh v-model="list.refreshLoading" @refresh="onRefresh">
          <list
            v-model="list.loading"
            :finished="list.finished"
            :error.sync="list.error"
            error-text="请求失败，点击重新加载"
            finished-text="没有更多了"
            @load="getList"
          >
            <wy-card
              v-for="(item, index) in list.data"
              :key="index"
              margin="0 0 0.1rem 0"
              padding="0.15rem 0.1rem 0.15rem 0.15rem"
            >
              <div class="list-item">
                <van-row class="list-item-box">
                  <van-col span="5" class="tl list-item-left" @click="detailFn(item)">
                    <van-image
                      fit="contain"
                      width="0.48rem"
                      height="0.48rem"
                      :src="item.company_logo"
                    >
                      <img slot="error" src="http://m.kzp.rendd.cn/static/imgs/null.png" alt />
                    </van-image>
                  </van-col>
                  <van-col span="14" class="tl list-item-center" @click="detailFn(item)">
                    <div class="title-sm">{{item.company_name}}</div>
                    <div class="padding">
                      <span class="item-view">
                        <span class="iconfont icon-yanjing"></span>
                        <span>{{item.view_nums}}</span>
                      </span>
                      <span>| {{item.city}}</span>
                      <span>| {{item.industry}}</span>
                      <!-- <span v-if="item.jobs && item.jobs.length > 0">| 在招职位{{item.jobs.length}}个</span> -->
                    </div>
                    <div v-if="item.jobs">
                      <swipe
                        :show-indicators="false"
                        :touchable="false"
                        :autoplay="3000"
                        :height="18"
                        vertical
                        style="height: 18px; line-height: 18px;"
                      >
                        <swipe-item
                          class="ellipsis"
                          v-for="(job, number) in item.jobs"
                          :key="number"
                        >
                          <span>{{job.city_name}}</span>
                          <span>{{job.salary}}</span>
                          <span>{{job.job_name}}</span>
                        </swipe-item>
                      </swipe>
                    </div>
                  </van-col>
                  <van-col span="5" class="list-item-right">
                    <span
                      :class="checkState(queueObj[item.video_erp_register_id])"
                      @click="dealQueuey(item)"
                    >
                      <span class="video">
                        <span class="iconfont icon-Icon-shipin"></span>
                      </span>
                      <br />
                      <span class="video-text" v-if="queueObj[item.video_erp_register_id]">
                        <span v-if="queueObj[item.video_erp_register_id].interview_state == 2">已面试</span>
                        <span v-else>
                          <span v-if="queueObj[item.video_erp_register_id].state * 1 === 1">发起视频</span>
                          <span
                            v-else
                          >{{queueState[queueObj[item.video_erp_register_id].state + '-' + queueObj[item.video_erp_register_id].type]}}</span>
                        </span>
                      </span>
                      <span class="video-text" v-else>面试排队</span>
                    </span>
                  </van-col>
                </van-row>
                <van-row
                  v-if="queueObj[item.video_erp_register_id] && queueObj[item.video_erp_register_id].interview_time"
                  :class="'list-item-bottom ' + (queueObj[item.video_erp_register_id].is_over ? 'light-height':'gray')"
                  @click="detailFn(item)"
                >
                  <van-col span="12" class="tl ellipsis">
                    <span>面试：</span>
                    <span>{{queueObj[item.video_erp_register_id].interview_time}}</span>
                  </van-col>
                  <van-col span="12" class="tr ellipsis">
                    <span>{{queueObj[item.video_erp_register_id].job_name}}</span>
                  </van-col>
                </van-row>
                <div class="apply-sign" v-if="companyOnline[item.video_erp_register_id]">
                  <span
                    class="apply-sign-warn"
                    v-if="companyBusiness[item.video_erp_register_id]"
                  >忙碌</span>
                  <span class="apply-sign-info" v-else>在线</span>
                </div>
                <div class="apply-sign" v-else>
                  <span>离线</span>
                </div>
              </div>
            </wy-card>
          </list>
        </pull-refresh>
      </section>
    </index-bar>

    <action-sheet
      v-model="showJob"
      :actions="actionsJob"
      @select="onSelectJob"
      title="选择职位"
      cancel-text="取消"
    />

    <popup v-model="popupShow" position="bottom" class="pop-box">
      <div class="pop-content">
        <nav-bar
          :title="detailData.company_name"
          left-text="返回"
          left-arrow
          @click-left="onClickLeft"
        >
          
        </nav-bar>
        <company-detail v-if="popupShow" :detail-data="detailData" @refresh="onRefresh(true)" />
        <!-- <icon class="pop-close" name="cross" @click="closePopFn" /> -->
      </div>
    </popup>
  </div>
</template>

<script>
import {
  Swipe,
  SwipeItem,
  List,
  PullRefresh,
  Field,
  CellGroup,
  ActionSheet,
  IndexBar,
  IndexAnchor,
  Popup,
  NavBar
} from "vant";
import WyCard from "@/components/WyCard";

import CompanyDetail from "@/pages/company/Detail";

import { mapState } from "vuex";

export default {
  name: "company-list",
  components: {
    Swipe,
    SwipeItem,
    List,
    PullRefresh,
    Field,
    CellGroup,
    ActionSheet,
    WyCard,
    IndexBar,
    IndexAnchor,
    Popup,
    NavBar,
    CompanyDetail
  },
  computed: {
    ...mapState({
      route: state => state.route,
      sign: state => state.sign,
      myApplyObj: state => state.myApplyObj,
      queueState: state => state.queueState,
      queueType: state => state.queueType,
      companyOnline: state => state.companyOnline,
      companyBusiness: state => state.companyBusiness,
      user_name: state => state.user_name,
      seeker_openid: state => state.seeker_openid,
      queueObj: state => state.queueObj
    })
  },
  data() {
    return {
      images: ["/img/banner_company.png"],
      list: {
        data: [],
        loading: false,
        finished: false,
        error: false,
        params: {
          pageNo: 1,
          pageSize: 30,
          keyword: "",
          city: "",
          industry: "",
          video_jobfair_id: ""
        },
        refreshLoading: false,
        searchLoading: false
      },
      jobfair_name: "",
      SelectList: [{ name: "主办方", checked: true }, { name: "城市" }],
      video_jobfair_id: "",
      loadData: false,

      showJob: false,
      actionsJob: [],
      startSendTimer: null,
      popupShow: false,
      detailData: {}
    };
  },
  created() {
    const video_jobfair_id = this.$util.getQueryString("video_jobfair_id");
    this.video_jobfair_id = video_jobfair_id;
    this.init();

    const title = this.$util.getQueryString("title") || "";

    this.$store.commit("setSubTitle", {
      title: title
    });

    this.$store.commit("updateCheckedjobfair", {
      name: title,
      video_jobfair_id: video_jobfair_id,
      data: {}
    });
  },
  mounted() {
    let { user_name, video_jobfair_id } = this;
    if (user_name && video_jobfair_id) {
      this.$store.commit("update_single_state", {
        key: "websocket_send_data",
        data: {
          flag: "area",
          time: new Date().getTime(),
          business_txt: user_name + "进入会场",
          business_type: "会场动态",
          business_id: "",
          group_id: video_jobfair_id
        }
      });
    }
  },
  methods: {
    init() {
      let that = this;
      const { video_jobfair_id, myApplyObj, sign } = that;
      if (!video_jobfair_id) {
        that.$dialog
          .alert({
            title: "参数错误",
            message: "点击确定将回到视频双选会列表界面"
          })
          .then(() => {
            that.$router.push({ path: "/" });
          });
        return;
      }

      //TODO:: 检查是否已经登录

      // 判断是否已报名
      if (!myApplyObj[video_jobfair_id]) {
        that.$store
          .dispatch("registerJobfair", { sign, video_jobfair_id })
          .then(res => {
            const { code } = res;
            if (code === 1) {
              that.beginLoad(video_jobfair_id);

              setTimeout(() => {
                that.$dialog
                  .alert({
                    title: "报名成功!",
                    message: "简历完善度达到70%以上可获得更多面试机会哦!"
                  })
                  .then(() => {});
              }, 1500);
            } else {
              that.$router.push({ path: "/" });
            }
          });
        return;
      }

      that.beginLoad(video_jobfair_id);
    },
    beginLoad(video_jobfair_id) {
      this.checkAttention();

      this.$set(this.list.params, "video_jobfair_id", video_jobfair_id);
      this.loadData = true;
      this.getAllQueue().then(res => {
        const { code } = res;
        if (code !== 1) {
          this.getAllQueue();
        }
      });
    },
    onRefresh(silent) {
      let that = this;

      this.getAllQueue();

      that.$set(that.list.params, "pageNo", 1);
      that.getList().then(() => {
        if (silent === true) {
          return;
        }
        setTimeout(() => {
          that.$set(that.list, "refreshLoading", false);
          that.$notify({
            message: "刷新完成",
            type: "primary"
          });
        }, 1000);
      });
    },
    getList() {
      let that = this;

      const { params } = this.list;

      return new Promise(resolve => {
        that.$util
          .get("kzp_video_jobfair", "company_list", params)
          .then(res => {
            const { code, msg, data } = res;
            // 加载状态结束
            that.$set(that.list, "loading", false);
            if (code === 1) {
              const { items, total } = data;

              if (params.pageNo === 1) {
                that.$set(that.list, "finished", false);
                that.$set(that.list, "data", items);
              } else {
                that.$set(that.list, "data", [...that.list.data, ...items]);
              }

              that.reSortFn();

              // 数据全部加载完成
              if (
                items.length < params.pagesize ||
                that.list.data.length >= total
              ) {
                that.$set(that.list, "finished", true);
              } else {
                that.$set(that.list.params, "pageNo", params.pageNo + 1);
              }
            } else {
              that.$set(that.list, "error", true);
              that.$notify({
                message: msg || "获取数据失败，请稍后再试！",
                type: "danger"
              });
            }

            resolve();
          });
      });
    },
    reSortFn() {
      let that = this;

      // 重新排序：1、已排队的在前，2、在线空闲的在前，3、在线的在前
      let arr_sort_free = [];
      let arr_sort = [];
      let arr_free = [];
      let arr_busy = [];
      let arr_other = [];

      const { companyOnline, companyBusiness, queueObj } = that;

      that.list.data.forEach(item => {
        const { video_erp_register_id } = item;

        if (companyOnline[video_erp_register_id]) {
          if (companyBusiness[video_erp_register_id]) {
            arr_busy.push(item);
          } else if (queueObj[video_erp_register_id]) {
            arr_sort_free.push(item);
          } else {
            arr_free.push(item);
          }
        } else if (queueObj[video_erp_register_id]) {
          arr_sort.push(item);
        } else {
          arr_other.push(item);
        }
      });

      that.$set(that.list, "data", [
        ...arr_sort_free,
        ...arr_sort,
        ...arr_free,
        ...arr_busy,
        ...arr_other
      ]);
      that.$forceUpdate();
    },
    getAllQueue() {
      // 获取当前双选会所有排队信息

      const { video_jobfair_id, sign } = this;
      let that = this;
      const params = {
        video_jobfair_id,
        sign
      };

      return new Promise(resolve => {
        that.$util
          .get("kzp_video_jobfair", "my_all_video_invitation", params)
          .then(res => {
            const { code, data } = res;
            if (code === 1) {
              let queueObj = {};
              // 更新申请排队记录
              if (data && data.items) {
                data.items.forEach(item => {
                  const { video_erp_register_id } = item;
                  queueObj[video_erp_register_id] = item;
                });
              }

              that.$store.commit("update_single_state", {
                key: "queueObj",
                data: queueObj
              });

              that.$forceUpdate();
            }
            resolve(res);
          });
      });
    },
    searchFn() {
      let that = this;
      const { jobfair_name } = that;

      if (that.list.searchLoading) {
        that.$notify({
          message: "数据正在查询中,请稍候...",
          type: "warning"
        });
        return;
      }

      that.$set(that.list.params, "pageNo", 1);
      that.$set(that.list.params, "keyword", jobfair_name);

      that.$set(that.list, "searchLoading", true);
      that.getList().then(() => {
        that.$set(that.list, "searchLoading", false);
      });
    },
    detailFn(item) {
      const { company_id, video_erp_register_id, video_jobfair_id } = item;
      const path = "/sub/company-detail?company_id=" +
          company_id +
          "&video_erp_register_id=" +
          video_erp_register_id +
          "&video_jobfair_id=" +
          video_jobfair_id

      // 弹窗查看详情
      // this.detailData = item;
      // this.popupShow = true;
      // sessionStorage.setItem("current_url", path);

      // 跳转页面查看详情
      this.$router.push({path})
    },
    showJobFn(item) {
      let actionsJob = [];
      if (item.jobs) {
        item.jobs.forEach(job => {
          actionsJob.push({
            name: job.job_name,
            subname: job.salary,
            publish_id: job.publish_id,
            data: item
          });
        });
      }

      if (actionsJob.length <= 0) {
        this.$notify({
          message: "当前公司没有在招职位,无法申请!",
          type: "warning"
        });
        return;
      }

      this.actionsJob = actionsJob;
      this.showJob = true;
    },
    onSelectJob(item) {
      const { publish_id, data, name } = item;

      let that = this;

      that.showJob = false;

      const { video_erp_register_id } = data || {};

      if (!video_erp_register_id) {
        that.$notify({
          message: "参数错误!",
          type: "warning"
        });
        return;
      }

      this.$util
        .makesueTwice({
          title: "面试排队?",
          message:
            "确认申请" + data.company_name + "公司的" + name + "职位的面试排队?"
        })
        .then(res => {
          if (res) {
            that.submitQueue(publish_id, name, data).then(res => {
              const { code, data } = res;
              if (code === 1) {
                // 告诉企业
                that.$store.commit("update_single_state", {
                  key: "websocket_send_data",
                  data: {
                    flag: "notice",
                    msg_from: "user",
                    receiver_uid: video_erp_register_id,
                    business_type: "申请",
                    business_id: data,
                    business_txt:
                      (that.user_name || "") + "申请了你发布的职位" + name
                  }
                });
                // 提示排队成功
                that.$notify({
                  message: "申请面试排队成功，待企业确认!",
                  type: "success"
                });
              }
            });
          }
        });
    },
    dealQueuey(item) {
      // 判断当前是否已排队
      const { video_erp_register_id } = item;

      const { queueObj, companyOnline, companyBusiness } = this;

      let that = this;

      const data = queueObj[video_erp_register_id];
      if (data) {
        const { interview_state, state, invitation_apply_id } = data;
        //发起视频
        if (
          invitation_apply_id &&
          parseInt(interview_state) !== 2 &&
          parseInt(state) === 1
        ) {
          if (companyBusiness[video_erp_register_id]) {
            that.$dialog.alert({
              title: "忙碌中",
              message: "企业正在忙碌中，请稍后再试!"
            });
            return;
          }

          if (companyOnline[video_erp_register_id]) {
            // 查询当前的状态
            that.getApplyDetail(invitation_apply_id).then(({ code, data }) => {
              if (code !== 1) {
                that.onRefresh(true);
                return;
              }

              const { interview_state, state } = data || {};
              if (parseInt(state) !== 1 || parseInt(interview_state) === 2) {
                that.$dialog.alert({
                  title: "暂时不能发起视频",
                  message: "当前排队状态已改变，已为您更新为最新数据!"
                });
                that.onRefresh();
                return;
              }

              // 向企业发起视频
              that.beginInterview(invitation_apply_id, video_erp_register_id);
            });
          } else {
            // 提示hr不在线，只有当hr在线时才能发起视频
            that.$dialog.alert({
              title: "当前企业不在线",
              message: "只有企业在线时才能发起视频!"
            });
          }
          return;
        }

        // 进入公司详情页面处理
        that.detailFn(item);
      } else {
        // 否：选择职位->二次确定->排队
        that.showJobFn(item);
      }
    },
    submitQueue(publish_id, job_name, item) {
      const {
        video_erp_register_id,
        company_id,
        company_name,
        video_jobfair_id
      } = item;

      const { sign } = this;

      let that = this;

      const params = {
        publish_id,
        job_name,
        company_name,
        video_erp_register_id,
        company_id,
        video_jobfair_id,
        sign
      };

      that.$toast.loading({
        duration: 0,
        message: "加载中...",
        forbidClick: true
      });

      return new Promise(resolve => {
        that.$util.post("kzp_video_jobfair", "apply", params).then(res => {
          const { msg, code, data } = res;

          that.$toast.clear();

          if (code === 1) {
            // 更新申请排队记录
            let queueObj = that.queueObj;
            queueObj[video_erp_register_id] = {
              invitation_apply_id: data,
              state: 0,
              type: 1
            };
            that.$store.commit("update_single_state", {
              key: "queueObj",
              data: queueObj
            });

            that.$forceUpdate();
          } else {
            // 提示错误
            that.$notify({
              message: msg || "排队失败,请稍后再试!",
              type: "danger"
            });

            that.$util.goToWxResume(msg);
          }
          resolve(res);
        });
      });
    },
    checkState(item) {
      const { companyBusiness, companyOnline } = this;

      const { video_erp_register_id, state, interview_state } = item || {};

      const gray_class = "span-gray";
      const nomal_class = "";

      if (!video_erp_register_id) {
        return nomal_class;
      }

      if (interview_state && parseInt(interview_state) === 2) {
        // 面试已结束
        return gray_class;
      }

      if (companyOnline[video_erp_register_id]) {
        if (companyBusiness[video_erp_register_id]) {
          // 忙碌
          return gray_class;
        } else {
          // 在线 空闲
          if (state && state * 1 === 2) {
            // 已拒绝
            return gray_class;
          } else {
            return nomal_class;
          }
        }
      } else {
        // 不在线
        if (state && state * 1 > 0) {
          // 已申请、已处理
          return gray_class;
        } else {
          // 未申请
          return nomal_class;
        }
      }
    },
    checkAttention() {
      let that = this;

      if (sessionStorage.getItem("attention_yunjiuye")) {
        return;
      }

      const { seeker_openid, sign } = that;

      that.$store
        .dispatch("getSubscribe", { sign, openid: seeker_openid })
        .then(res => {
          const { code, data } = res;

          if (code === 1 && data === 0) {
            // 提示未关注云就业公众号
            that.$dialog
              .alert({
                title: "即时面试，您只差一个【云就业】!",
                message:
                  "微信搜索并关注【云就业】公众号,即可即时接收企业的面试提醒, 您可以点击模板消息直接进入面试间进行面试!",
                confirmButtonText: "我知道啦 !"
              })
              .then(() => {
                sessionStorage.setItem("attention_yunjiuye", 1);
              });
          }
        });
    },
    beginInterview(invitation_apply_id, video_erp_register_id) {
      let that = this;
      that.$util
        .makesueTwice({
          title: "向企业发起视频",
          message:
            "确定向企业发起视频? 点击确定后会向企业发起视频请求，如果超过45s企业未应答会自动断开。"
        })
        .then(res => {
          if (res) {
            const { user_name } = that;
            // 发起视频请求
            that.$store.commit("update_single_state", {
              key: "websocket_send_data",
              data: {
                flag: "notice",
                receiver_uid: video_erp_register_id,
                business_txt: user_name + "向你发起了面试申请",
                business_type: "面试",
                business_id: invitation_apply_id
              }
            });

            // 等待企业的反馈
            that.$store.commit(
              "update_wait_invitation_apply_id",
              invitation_apply_id
            );
          }
        });
    },
    getApplyDetail(invitation_apply_id) {
      let that = this;
      return new Promise(resolve => {
        const { sign } = that;
        const params = {
          invitation_apply_id,
          sign
        };

        that.$util
          .get("kzp_video_jobfair", "video_invitation_detail", params)
          .then(res => {
            const { code, msg } = res;
            if (code !== 1) {
              that.$notify({
                message: msg || "获取数据失败，请稍后再试！",
                type: "danger",
                onClose: () => {}
              });
            }

            resolve(res);
          });
      });
    },
    onClickLeft() {
      this.popupShow = false;
      sessionStorage.setItem("current_url", location.href);
    }
  }
};
</script>

<style lang="scss" scoped>
.jobfair-list {
  img {
    max-width: 100%;
    max-height: 100%;
  }

  .list {
    padding: 0.15rem;

    .list-item {
      position: relative;
      .apply-sign {
        position: absolute;
        right: 0;
        top: -0.15rem;
        width: 0.5rem;

        > span {
          display: block;
          background-color: #f7f7f7;
          color: #999;
          padding: 0.02rem 0.06rem;
          font-size: 0.12rem;
          line-height: 0.14rem;
          overflow: hidden;
          @include box-sizing(border-box);
          @include border-radius(0 0 0.05rem 0.05rem);
          @include over-ellipsis();
        }

        .apply-sign-warn {
          background-color: #ff4343;
          color: #fff;
        }

        .apply-sign-info {
          background-color: #439bff;
          color: #fff;
        }
      }
    }

    .list-item-box {
      .list-item-left {
        padding: 0.05rem 0;
      }

      .list-item-center {
        color: #999;
        line-height: 0.14rem;
        font-size: 0.12rem;

        > div {
          @include over-ellipsis();
        }

        .ellipsis {
          > span {
            max-width: 40%;
            display: inline-block;
            @include over-ellipsis();
          }
        }

        .padding {
          padding: 0.03rem 0;
        }
      }

      .list-item-right {
        padding-top: 0.14rem;
        text-align: right;

        > span {
          display: inline-block;
          width: 0.5rem;
          text-align: center;

          .video-text {
            display: inline-block;
            padding-top: 0.05rem;
            line-height: 0.14rem;
            font-size: 0.12rem;
            color: #439bff;
            @include transform(scale(0.9, 0.9));
          }
        }

        .span-gray {
          .video-text {
            color: #999;
          }
          .video {
            background-color: #999999;
          }
        }

        .video {
          display: inline-block;
          width: 0.25rem;
          height: 0.25rem;
          text-align: center;
          line-height: 0.25rem;
          @include border-radius(50%);
          background-color: #439bff;
          color: #fff;
        }
      }
    }

    .list-item-bottom {
      margin-top: 0.1rem;
      padding-top: 0.1rem;
      color: #3a3a3a;
      font-size: 0.12rem;
      line-height: 0.16rem;
      border-top: 1px solid #f3f3f3;
    }

    .gray {
      div {
        color: #999;
      }
    }

    .light-height {
      div {
        color: #439bff;
      }
    }
  }

  .ellipsis {
    @include over-ellipsis();
  }

  .item-view {
    color: #999;
    font-size: 0.12rem;
    line-height: 0.14rem;
    // text-align: center;
    @include over-ellipsis();

    .iconfont {
      font-size: 0.12rem;
      line-height: 0.15rem;
    }
  }

  .pop-box {
    height: 100%;
    background-color: #f3f3f3;
    color: #333;
    overflow: hidden;
    .pop-content {
      height: 100%;
      overflow-y: auto;
    }
  }

  .pop-close {
    position: absolute;
    left: 0.1rem;
    top: 0.1rem;
    z-index: 99;
    font-size: 0.3rem;
    color: #fff;
    background-color: #3692e7;
    @include border-radius(0.05rem);
  }
}
</style>
